export default __webpack_public_path__ + "static/media/Shirting.9f18b911.png";